import { Avatar } from "@mui/material";
import React from "react";
import { Row, Col } from "react-bootstrap";
import * as constants from "../../Components/constants";
import Swal from "sweetalert2";
const BASE_IMG = constants.BASE_IMG;
const BASE_URL = constants.BASE_URL;

const Member = ({ allUser, groupID, handleUser }) => {
  const [invitedUsers, setInvitedUsers] = React.useState([]);

  const handleInvite = (user_Id) => {
    if (invitedUsers.includes(user_Id)) {
      alert("User already invited.");
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      width: 350,
      showCancelButton: true,
      confirmButtonColor: "#208637",
      cancelButtonColor: "#a51d2a",
      confirmButtonText: "Add",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${BASE_URL}/group/${groupID}/members/`, {
          method: "POST",
          headers: {
            Authorization: `Token ${localStorage.getItem("auth_token")}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            enable: true,
            role: "member",
            group: groupID,
            member: user_Id,
          }),
        })
          .then((res) => {
            if (res.status === 201) {
              return res.json();
            } else {
              throw new Error("Something went wrong");
            }
          })
          .then(() => {
            setInvitedUsers([...invitedUsers, user_Id]);
            Swal.fire({
              title: "Added!",
              text: "Member added successfully",
              width: 350,
            });
            handleUser("");
          })
          .catch((error) => {
            alert(error.message);
          });
      }
    });
  };

  return (
    <>
      <Row xs={1} md={2} className="g-4 mt-1">
        {allUser &&
          allUser.map((user, idx) => (
            <Col key={idx} onClick={() => handleInvite(user.id)}>
              <div className="d-flex" style={{ cursor: "pointer" }}>
                <Avatar
                  alt={user.first_name}
                  src={`${BASE_IMG}/media/${user.profile_pic}`}
                  sx={{ width: 50, height: 50 }}
                />
                <div className="mx-2 d-flex flex-column">
                  <b>{user.first_name}</b>
                  <span>Member</span>
                </div>
              </div>
            </Col>
          ))}
      </Row>
    </>
  );
};

export default Member;
